import { Observable, of } from 'rxjs';
import { Show } from '../models/show';

export class FakeHotBackend {
  getShows(): Observable<Show[]> {
    return of([
      {
        lineup: ['High Heat'],
        presale: '',
        offers: [],
        datetime: '2026-10-17T23:30:00',
        url: 'https://www.bandsintown.com/e/109021881?app_id=30a81df8fcf1081b54ad06163b7c1ff2&came_from=267&utm_medium=api&utm_source=public_api&utm_campaign=event',
        free: false,
        artist_id: '8037015',
        festival_start_date: '',
        ends_at: '2026-10-18T01:30:00',
        artist: {
          url: 'https://www.bandsintown.com/a/8037015?came_from=267&app_id=30a81df8fcf1081b54ad06163b7c1ff2',
          id: '8037015',
          name: 'High Heat',
          facebook_page_url: '',
          image_url: 'https://photos.bandsintown.com/large/23389721.jpeg',
          thumb_url: 'https://photos.bandsintown.com/thumb/23389721.jpeg',
          tracker_count: 212,
          links: [
            { type: 'youtube', url: 'https://www.youtube.com/@HighHeatRocks' },
            { type: 'itunes', url: 'https://music.apple.com/artist/1304906415?utm_source=bandsintown' },
            { type: 'website', url: 'http://highheatrocks.com' },
            { url: 'https://www.shazam.com/artist/-/1304906415?utm_source=bandsintown', type: 'shazam' },
            { url: 'http://facebook.com/highheatrocks', type: 'facebook' },
            { url: 'https://x.com/highheatrocks', type: 'twitter' },
            { url: 'http://www.instagram.com/highheatrocks/', type: 'instagram' },
            { url: 'https://open.spotify.com/artist/40PTC167k3JNNITfZL72aW', type: 'spotify' },
          ],
          support_url: '',
          options: { display_listen_unit: false },
          artist_optin_show_phone_number: false,
          show_multi_ticket: true,
          upcoming_event_count: 0,
          tracking: [],
          mbid: '',
        },
        venue: {
          postal_code: '37902',
          location: 'Knoxville, TN',
          name: 'Preservation Pub',
          latitude: '35.965539',
          longitude: '-83.919907',
          region: 'TN',
          street_address: '28 Market Sq',
          city: 'Knoxville',
          country: 'United States',
        },
        datetime_display_rule: 'range',
        sold_out: false,
        title: '',
        on_sale_datetime: '',
        id: '109021881',
        description: "Swing by for some gameday rock 'n' roll after the Vols beat Bama",
        festival_end_date: '',
        festival_datetime_display_rule: '',
        starts_at: '2026-10-17T23:30:00',
        bandsintown_plus: false,
      },
    ] as Show[]);
  }
}
